import type { PropertiesNullable } from '@@types/helpers'
import EntityBase from '@app/entities/EntityBase'
import type { IEntityListable } from '@app/entities/types'
import type {
  IDataRowGeneric,
  IWidgetListColumns
} from '@app/stores/helpers/StoreWidgetList/types'
import type {
  AttackPathAccountWithTier0AttackPath,
  AttackPathAdObjectType,
  Maybe
} from '@server/graphql/typeDefs/types'

export default class EntityAttackPathAccountWithTier0AttackPath
  extends EntityBase
  implements
    PropertiesNullable<AttackPathAccountWithTier0AttackPath>,
    IEntityListable<IDataRowGeneric>
{
  id: Maybe<number> = null
  name: Maybe<string> = null
  adObjectType: Maybe<AttackPathAdObjectType> = null
  directoryId: Maybe<number> = null
  location: Maybe<string> = null

  constructor(data: Partial<EntityAttackPathAccountWithTier0AttackPath>) {
    super()
    Object.assign(this, data)
  }

  /**
   * Not used, columns are hardcoded in the view with a custom render.
   */
  getColumns(): Array<IWidgetListColumns<IDataRowGeneric>> {
    return []
  }
}
